import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[asyncInsertionPoint]'
})
export class AsyncInsertionPointDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
